import { formatNumberBasedOnUser } from "utils/namesManipulation";

import type { EnergyAnalysisYearlyTableRow } from "../model/types";

import { toEnergyAnalysisLabel } from "./labels";

const formatTableNumber = (value: number | string) =>
  typeof value === "number" ? formatNumberBasedOnUser(value) : value;

export const buildEnergyAnalysisTableHeaders = (
  categoryKeys: string[],
  valueLabel: string,
  firstColumnLabel: string
) => [
  {
    dataKey: "rowLabel",
    headerClassName: "sentence-case",
    label: firstColumnLabel,
    valueTransformation: (row: EnergyAnalysisYearlyTableRow) => row.rowLabel,
  },
  {
    dataKey: "value",
    headerClassName: "sentence-case",
    label: valueLabel,
    valueTransformation: (row: EnergyAnalysisYearlyTableRow) => formatTableNumber(row.value),
  },
  ...categoryKeys.map((key) => ({
    dataKey: key,
    headerClassName: "sentence-case",
    label: toEnergyAnalysisLabel(key),
    valueTransformation: (row: EnergyAnalysisYearlyTableRow) => formatTableNumber(row[key] ?? ""),
  })),
];

export const buildEnergyAnalysisDownloadRows = (
  rows: EnergyAnalysisYearlyTableRow[],
  categoryKeys: string[],
  valueLabel: string,
  firstColumnLabel: string
) =>
  rows.map((row) => {
    const downloadRow: Record<string, number | string> = {
      [firstColumnLabel]: row.rowLabel,
      [valueLabel]: row.value,
    };
    categoryKeys.forEach((key) => {
      const cell = row[key];
      downloadRow[toEnergyAnalysisLabel(key)] = cell ?? 0;
    });
    return downloadRow;
  });
